import React from "react";
import {
  CheckboxGroupRHF,
  RadioGroupRHF,
  SelectRHF,
} from "../../components/RHFWrappedComponents";
import { CategoryContainer } from "../../components/CategoryContainer";
import {
  ancestryOptions,
  citizenStatusOptions,
  genderOptions,
  sexualityOptions,
  raceOptions,
  ethnicityOptions,
} from "../../data";

export function Demographics() {
  return (
    <CategoryContainer title="Demographics">
      <SelectRHF
        name="sensitive.gender"
        selectLabel="Gender"
        menuItemOptions={genderOptions}
      />
      <SelectRHF
        name="sensitive.sexuality"
        selectLabel="Self Identification"
        menuItemOptions={sexualityOptions}
      />
      <CheckboxGroupRHF
        name="sensitive.race"
        groupLabel="Race & Ethnicity"
        checkboxOptions={raceOptions}
      />
      <RadioGroupRHF
        name="sensitive.ethnicity"
        groupLabel="Do you identify as Hispanic?"
        radioGroupOptions={ethnicityOptions}
        row={true}
      />
      <SelectRHF
        name="sensitive.ancestry"
        selectLabel="Ancestry"
        menuItemOptions={ancestryOptions}
        multiple={true}
      />
      <SelectRHF
        name="sensitive.citizenshipStatuses"
        selectLabel="Citizen Status"
        menuItemOptions={citizenStatusOptions}
        multiple={true}
        footerText={
          "Your citizenship selection is only used to find scholarships for you and is not stored."
        }
      />
    </CategoryContainer>
  );
}
